import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const Root = styled.div`
  margin-top: 50px;
  text-align: center;
`;

const Title = styled(Typography)`
  margin-top: 20px;
`;

const ReloadButton = styled.div`
  color: ${theme.colors.primary[400]};
  text-decoration: underline;
  cursor: pointer;
`;

const StyledLink = styled(Link)`
  color: ${theme.colors.primary[400]};
  text-decoration: underline;
  cursor: pointer;
`;

const reloadLocation = () => window.location.reload();

const Error = ({ href, message, reload }) => (
  <Root data-testid="error">
    <Typography markupName="h3" variant="h3">
      Oops, something went wrong...
    </Typography>

    {message && <p>{message}</p>}

    <Title markupName="h3" variant="h3">
      {reload ? (
        <ReloadButton onClick={reloadLocation}>Let’s try again</ReloadButton>
      ) : (
        <StyledLink replace to={href}>
          Let’s try again
        </StyledLink>
      )}
    </Title>
  </Root>
);

Error.propTypes = {
  href: PropTypes.string,
  message: PropTypes.string,
  reload: PropTypes.bool,
};

Error.defaultProps = {
  href: '/consultation',
  message: null,
  reload: false,
};

export default Error;
